import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const plans = [
  {
    id: "essentiel",
    name: "Essentiel",
    price: "19,90",
    url: "https://buy.stripe.com/dRm9ATewk7084aY5BucfK01",
    tagline: "Pour commencer en douceur",
    features: [
      "Programme PDF de 21 nuits",
      "Journal du sommeil imprimable",
      "Exercices de respiration & relaxation",
    ],
    highlight: false,
  },
  {
    id: "complet",
    name: "Complet",
    price: "39,90",
    url: "https://buy.stripe.com/8x2eVddsgcks0YMaVOcfK02",
    tagline: "L’expérience complète",
    features: [
      "Tout le contenu Essentiel",
      "7 relaxations guidées audio",
      "3 ambiances sonores longues",
      "Module SOS sommeil",
    ],
    highlight: true,
  },
  {
    id: "premium",
    name: "Premium",
    price: "69,90",
    url: "https://buy.stripe.com/dRm4gzfAo84cfTG6FycfK03",
    tagline: "Accompagnement sur-mesure",
    features: [
      "Tout le contenu Complet",
      "Web app & programme personnalisé",
      "Suivi d’habitudes intelligent",
      "Recommandations quotidiennes",
    ],
    highlight: false,
  },
];

export const Pricing = () => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative mx-auto max-w-6xl scroll-mt-24 px-6 py-24 md:py-32 lg:px-10"
    >
      <Reveal className="mb-16 text-center">
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-[#c9a84c]">
          Tarifs
        </p>
        <h2 className="mx-auto max-w-2xl text-4xl font-light leading-tight tracking-tight sm:text-5xl">
          Choisis ta formule, paie une seule fois
        </h2>
      </Reveal>

      <div className="grid items-center gap-6 lg:grid-cols-3">
        {plans.map((plan, i) => (
          <Reveal
            key={plan.id}
            delay={i * 0.1}
            className={`card-line relative flex flex-col rounded-2xl border p-8 ${
              plan.highlight
                ? "border-[#c9a84c]/40 bg-[#211640] lg:scale-[1.05] lg:py-10"
                : "border-white/8 bg-[#1e1535]"
            }`}
          >
            {plan.highlight && (
              <span
                data-testid="popular-badge"
                className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[#c9a84c] px-4 py-1 text-xs font-semibold uppercase tracking-wider text-[#0a0e1a]"
              >
                Le plus populaire
              </span>
            )}

            <h3 className="text-xl font-medium tracking-tight text-white">
              {plan.name}
            </h3>
            <p className="mt-1 text-sm text-white/45">{plan.tagline}</p>

            <div className="mt-7 flex items-end gap-1">
              <span className="text-5xl font-light tracking-tighter text-white">
                {plan.price}
              </span>
              <span className="mb-1.5 text-xl text-white/50">€</span>
            </div>

            <ul className="mt-8 flex-1 space-y-3.5">
              {plan.features.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm text-white/75">
                  <Check
                    className="mt-0.5 h-4 w-4 flex-none text-[#c9a84c]"
                    strokeWidth={2}
                  />
                  {f}
                </li>
              ))}
            </ul>

            <a
              data-testid={`pricing-cta-${plan.id}`}
              href={plan.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`mt-9 block w-full rounded-full py-3.5 text-center text-sm font-semibold transition-colors duration-300 active:scale-[0.98] ${
                plan.highlight
                  ? "bg-[#c9a84c] text-[#0a0e1a] hover:bg-[#e8c97a]"
                  : "border border-white/15 text-white hover:border-[#c9a84c]/50 hover:bg-white/5"
              }`}
            >
              Choisir {plan.name}
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-12 text-center text-sm text-white/45">
          Envie d’aller plus loin&nbsp;? Abonnement optionnel à{" "}
          <span className="text-[#e8c97a]">4,90 €/mois</span> — nouvelles histoires,
          méditations et ambiances chaque mois.
        </p>
      </Reveal>
    </section>
  );
};
